
import '../../styles/LandingPageCss/MainHomeSection.css'
import google from "../../../../../images/LandingPageImage/google.png"
import about from "../../../../../images/LandingPageImage/message_notifier_about_us__1x.webp"
import { useModal } from '../../../../../MyContext'
import { Link } from 'react-router-dom'


export default function About() {
    const { openModal } = useModal();
    return (
        <>
            <section className="hero-section py-5 py-md-5 font-inter">
                <div className="container px-3 px-lg-4">

                    <div className="row align-items-center gx-lg-5 gy-5">


                        <div className="col-12 col-md-6 order-2 order-md-1">
                            <div className="hero-content text-center text-md-start">
                                <h1 className="hero-title text-purple font-spacegrotesk fw-semibold">
                                    Powering Business Conversations on WhatsApp
                                </h1>

                                <p className="hero-subtitle mt-3">
                                    At MsgNotifier, we believe that meaningful conversations drive business growth. WhatsApp has become the most powerful communication channel for customers today, and we help businesses use it the right way. Our platform is built to enable fast, reliable, and personalized communication that turns everyday chats into valuable customer experiences.

                                </p>

                                <p className="hero-subtitle d-none d-sm-block">
                                    From customer engagement to lead generation and support automation, MsgNotifier empowers brands to communicate smarter, respond faster, and grow stronger through WhatsApp.
                                </p>

                                <div className="d-flex gap-3 mt-4 justify-content-center justify-content-lg-start flex-wrap">
                                     <Link to="/login" className="text-decoration-none"> 
                                    <button className="btn d-flex align-items-center bg-neon-purple rounded-1 text-white justify-content-center gap-2 home-btn-primary fw-medium hover-scale">

                                        <span
                                            className="rounded-circle bg-white d-flex align-items-center justify-content-center flex-shrink-0"
                                            style={{ width: "30px", height: "30px" }}
                                        >
                                            <img
                                                src={google}
                                                alt="Google"
                                                style={{ width: "20px", height: "20px" }}
                                                className="img-fluid"
                                            />
                                        </span>


                                        <span className="text-nowrap fs-6">
                                            Start With Google
                                        </span>
                                    </button>
                                    </Link>
                                    <button
                                        onClick={openModal}
                                        className="btn d-flex align-items-center justify-content-center bg-white rounded-1   home-btn-secondary fw-medium">
                                        <span className="text-nowrap fs-5">Book a Demo</span>
                                    </button>
                                </div>
                            </div>
                        </div>


                        <div className="col-12 col-md-6 order-1 order-md-2">
                            <div className="hero-image-wrapper d-flex justify-content-center align-items-center">
                                <div className="hero-circle-bg">

                                    <div className="circle-element "></div>
                                    <img
                                        src={about}
                                        alt="WhatsApp marketing dashboard"
                                        className="hero-img img-fluid  rounded-4"
                                    />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            <section className="about-section font-inter text-center text-white d-flex align-items-center">
                <div className="container">


                    <h1 className="new-section-title font-spacegrotesk">
                        Helping Businesses Grow Smarter
                        <br />
                        with WhatsApp Automation
                    </h1>


                    <p className="about-text text-dark">
                        Modern customers expect instant replies and relevant interactions. Manual messaging is no longer enough. That’s where MsgNotifier steps in.
                    </p>

                    <p className="about-text text-dark">
                        We help businesses grow smarter by automating WhatsApp conversations without losing the human touch. Our automation tools allow you to respond 24/7, guide users through smart conversation flows, and manage thousands of interactions effortlessly.

                    </p>

                    <p className="about-text text-dark mb-5">

                        With MsgNotifier, businesses can reduce response time, improve customer satisfaction, and increase conversions all while saving time and operational costs.

                    </p>


                    <div className="row g-4 justify-content-center">


                        <div className="col-md-6">
                            <div className="info-card text-start vision-card">
                                <h3 className='text-dark font-spacegrotesk'>Our Vision</h3>
                                <p>
                                    To become a trusted global platform that transforms WhatsApp into the most effective business communication and customer engagement channel.

                                </p>
                            </div>
                        </div>


                        <div className="col-md-6">
                            <div className="info-card text-start  mission-card">
                                <h3 className='font-spacegrotesk text-dark'>Our Mission</h3>
                                <p>
                                    Our mission is to empower businesses of all sizes with simple,
                                    secure, and scalable WhatsApp automation tools that help them
                                    connect, engage, and convert customers more efficiently. We aim
                                    to bridge the gap between businesses and customers by making
                                    conversations faster, smarter, and more meaningful.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            <section className="who-section font-inter text-center px-3 px-md-0 text-white d-flex align-items-center py-5">
                <div className="container">

                    <h1 className="who-title font-spacegrotesk mb-2">
                        What We Do
                    </h1>

                    <p className="who-text text-dark mb-4 px-3 px-md-0">
                        At MsgNotifier, we provide an all-in-one WhatsApp communication platform designed for business growth.
                    </p>


                    <div className="row g-4 g-md-5 who-card justify-content-center mt-0">
                        <div className="col-12 col-md-6">
                            <div className="text-start pe-md-3">
                                <div className="mb-4">
                                    <h3 className="text-white font-spacegrotesk mb-2">WhatsApp Campaign Management</h3>
                                    <p className="mb-0">Run bulk messaging campaigns, promotional broadcasts, and personalized outreach with high delivery and engagement rates.</p>
                                </div>
                                <div className="mb-4">
                                    <h3 className="text-white font-spacegrotesk mb-2">Automated Replies & Smart Flows</h3>
                                    <p className="mb-0">Create automated responses, interactive chat flows, and instant replies to handle customer queries 24/7.</p>
                                </div>
                                <div>
                                    <h3 className="text-white font-spacegrotesk mb-2">Audience Targeting & Segmentation</h3>
                                    <p className="mb-0">Segment your audience based on behavior, interests, and engagement to send the right message to the right people.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6">
                            <div className="text-start ps-md-3">
                                <div className="mb-4">
                                    <h3 className="text-white font-spacegrotesk mb-2">Personalized Messaging</h3>
                                    <p className="mb-0">Deliver tailored messages using customer data to improve engagement, trust, and conversions.</p>
                                </div>
                                <div>
                                    <h3 className="text-white font-spacegrotesk mb-2">Analytics & Performance Tracking</h3>
                                    <p className="mb-0">Track message delivery, engagement, and campaign performance to continuously optimize your WhatsApp strategy.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    );
}
